import React from 'react'
import './Style/Footer.css'

function Footer({data,product,total,lastPrice,discount}) {
  return <div className='footer'>
        <div className='container'>
            <div className='row'>
                <div className='col-md-4 footer-left-side d-flex flex-column-reverse'>
                  <div className='customer-info'>
                      <h1> Invoice to :  </h1>
                      <p className='Customer'> #Customer Name </p>
                      <h1 className='location'> location : </h1>
                      <span className='lead'> Lorem ipsum dolor sit, amet consectetur adipisicing elit. </span>
                  </div>
                  <div className='terms'>
                    <h1>Terms & Conditions</h1>
                    <p className='lead'> Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora illum eveniet repellendus ipsam rem sunt dolore quisquam, adipisci odio. Neque, corporis optio? </p>
                  </div>
                </div>

                <div className='col-md-8 footer-right-side'>

                    <h3 className='thansks'> Thank you for your business </h3>
                    <h1 className='Payment'> Payment Info: </h1>

                    <div className='Payment-info'>
                      <div>
                        {data.map((item)=>(
                          <p className='Payment'> {item.label }</p>
                        ))}
                      </div>
                      <div>
                        {data.map((item)=>(
                          <span className='Payment'>: {item.value}</span>
                        ))}
                      </div>
                    </div>

                    <div className='total-price'>
                      <div>
                          <h1 className='sub-total'> Sub Total  </h1> 
                          <h1 className='discount'> Discount(%{product.discount})  </h1> 
                          <h1 className='sub-total'> Total  </h1> 
                      </div>
                      <div>
                        <p className='mony'> ${total} </p>
                        <p className='mony'> ${discount} </p>
                        <p className='mony'> ${lastPrice} </p>
                      </div>
                    </div>
                    <h1 className='authorised'> Authorised sign </h1>

                </div>
            </div>
        </div>
  </div>
}

export default Footer